export const getPaddedDateTImeNumber = (num: number): string => num.toString().padStart(2, '0');
